import React from 'react';
import styled from 'styled-components';
import { isEmpty } from "lodash";

export function capitalizeFirstLetter(wordValue) {
    if (wordValue.length > 0) {
        return wordValue.charAt(0).toUpperCase() + wordValue.slice(1);
    }
    return wordValue;
}

export function CharacterCount({ count, maxCount }) {
    const remainingCount = maxCount - count;
    return <p>{remainingCount} characters remaining</p>;
}

// can pass through data to ensure values are inputed
export function validateRecords(data, messages) {
    const errors = {};
    data.forEach((record, index) => {
        Object.keys(record).forEach((fieldName) => {
            if (isEmpty(record[fieldName])) {
                const defaultMessage = `${fieldName.charAt(0).toUpperCase() + fieldName.slice(1)} is required`;
                errors[`${fieldName}${index}`] = messages?.[fieldName] || defaultMessage;
            }
        });
    });
    return errors;
}

export function getWizardSteps(jodData) {
    const wizardSteps = jodData.jobType === 'Operational' ?
        [
            { label: 'Vacancy Information', number: 1, completed: false },
            { label: 'Employment History', number: 2, completed: false },
            { label: 'Other Qualifications', number: 3, completed: false },
            { label: 'Other Information', number: 4, completed: false },
            { label: 'Referees', number: 5, completed: false },
            { label: 'Declaration', number: 6, completed: false },
            { label: 'Equal Opportunities Monitoring', number: 7, completed: false },
        ] :
        [
            { label: 'Vacancy Information', number: 1, completed: false },
            { label: 'Employment History', number: 2, completed: false },
            { label: 'Education', number: 3, completed: false },
            { label: 'Other Qualifications', number: 4, completed: false },
            { label: 'Other Information', number: 5, completed: false },
            { label: 'Referees', number: 6, completed: false },
            { label: 'Declaration', number: 7, completed: false },
            { label: 'Equal Opportunities Monitoring', number: 8, completed: false },
        ];
    return wizardSteps;
}



export function ProgressBar({ progress }) {
    const ProgressBar = styled.div`
  height: 15px;
  width: 100%;
  background-color: #c5c5c5;
  margin-bottom: 20px;
 position: relative; /* Add this to position the label */
  background-image: 
    repeating-linear-gradient(
      -45deg, 
      transparent, 
      transparent 1rem,
      #ccc 1rem,
      #ccc 2rem
    );
  background-size: 200% 200%;
    animation: barberpole 25s linear infinite;
}

@keyframes barberpole {
  100% {
    background-position: 100% 100%;
  }
}
`;

    const Progress = styled.div`
  height: 100%;
  background-color: #007bff;
  width: ${({ progress }) => `${progress}%`};
  transition: width 0.3s ease-in-out;
`;

    return (
        <ProgressBar>
            <Progress progress={progress} />
        </ProgressBar>
    );
}



export const loadingStyles = {
    loadingScreen: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.89)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        zIndex: 9999
    },
    loadingSpinner: {
        border: "16px solid #f3f3f3",
        borderTop: "16px solid #3498db",
        borderRadius: "50%",
        width: 120,
        height: 120,
        animation: "spin 2s linear infinite"
    },
    loadingText: {
        marginTop: 20,
        fontSize: 20,
        color: "#fff"
    },
    "@keyframes spin": {
        "0%": {
            transform: "rotate(0deg)"
        },
        "100%": {
            transform: "rotate(360deg)"
        }
    }
};
